import isObject from "modules/isObject";

export default (obj = {}) =>
  isObject(obj) ? Object.keys(obj).sort().reverse() : [];
